// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alapadatok-container {
    padding: 30px;
    width: 100%; /* A teljes szélesség kihasználása */
    max-width: 1200px; /* Maximum szélesség */
    margin: 0 auto;
    background-color: #ffffff; /* Fehér háttér */
    border-radius: 10px;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1); /* Enyhe árnyék */
    display: flex;
    flex-direction: column;
}

.alapadatok-container h1 {
    color: #44ACC9;
    margin-bottom: 30px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
}

form {
    display: flex;
    flex-direction: column;
    gap: 20px; /* Térköz a form csoportok között */
    width: 100%; /* A form is kihasználja a teljes szélességet */
}

.form-group {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
}

.form-group label {
    display: block;
    margin-bottom: 8px; /* Nagyobb hely a címkék alatt */
    color: #333;
    font-weight: 600;
}

.form-group input, 
.form-group select, 
.form-group textarea {
    width: 100%;
    padding: 12px; /* Nagyobb padding */
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px; /* Nagyobb betűméret */
}

.specializacio-options {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 10px;
}

.specializacio-options label {
    margin-right: 20px;
    font-weight: 500;
    color: #555;
}

.specializacio-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.specializacio-item label {
    margin-left: 10px;
    font-weight: 500;
    color: #555;
}

.specializacio-item input {
    flex-shrink: 0;
    margin-right: 10px;
}

button {
    padding: 12px 20px;
    background-color: #44ACC9;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    font-size: 16px; /* Nagyobb gomb szöveg */
    font-weight: bold;
    align-self: flex-end; /* Igazítás jobbra */
}

button:hover {
    background-color: #3a94b1;
}

/* Responsive stílusok */
@media (max-width: 768px) {
    .alapadatok-container {
        padding: 20px;
        max-width: 100%; /* Kis képernyőn teljes szélességet használ */
    }

    form {
        gap: 15px; /* Kisebb térköz a form elemek között */
    }

    .form-group input, 
    .form-group select, 
    .form-group textarea {
        padding: 10px; /* Kisebb padding kisebb képernyőkön */
        font-size: 14px; /* Kisebb betűméret kisebb képernyőkön */
    }

    button {
        padding: 10px 15px; /* Kisebb gomb méret kisebb képernyőkön */
        font-size: 14px; /* Kisebb gomb szöveg */
    }
}
`, "",{"version":3,"sources":["webpack://./src/routes/Alapadatok.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW,EAAE,oCAAoC;IACjD,iBAAiB,EAAE,sBAAsB;IACzC,cAAc;IACd,yBAAyB,EAAE,iBAAiB;IAC5C,mBAAmB;IACnB,2CAA2C,EAAE,iBAAiB;IAC9D,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS,EAAE,mCAAmC;IAC9C,WAAW,EAAE,+CAA+C;AAChE;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,kBAAkB,EAAE,gCAAgC;IACpD,WAAW;IACX,gBAAgB;AACpB;;AAEA;;;IAGI,WAAW;IACX,aAAa,EAAE,oBAAoB;IACnC,sBAAsB;IACtB,kBAAkB;IAClB,eAAe,EAAE,sBAAsB;AAC3C;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,eAAe,EAAE,wBAAwB;IACzC,iBAAiB;IACjB,oBAAoB,EAAE,oBAAoB;AAC9C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB;IACI;QACI,aAAa;QACb,eAAe,EAAE,6CAA6C;IAClE;;IAEA;QACI,SAAS,EAAE,uCAAuC;IACtD;;IAEA;;;QAGI,aAAa,EAAE,sCAAsC;QACrD,eAAe,EAAE,wCAAwC;IAC7D;;IAEA;QACI,kBAAkB,EAAE,yCAAyC;QAC7D,eAAe,EAAE,uBAAuB;IAC5C;AACJ","sourcesContent":[".alapadatok-container {\n    padding: 30px;\n    width: 100%; /* A teljes szélesség kihasználása */\n    max-width: 1200px; /* Maximum szélesség */\n    margin: 0 auto;\n    background-color: #ffffff; /* Fehér háttér */\n    border-radius: 10px;\n    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1); /* Enyhe árnyék */\n    display: flex;\n    flex-direction: column;\n}\n\n.alapadatok-container h1 {\n    color: #44ACC9;\n    margin-bottom: 30px;\n    text-align: center;\n    font-size: 24px;\n    font-weight: bold;\n}\n\nform {\n    display: flex;\n    flex-direction: column;\n    gap: 20px; /* Térköz a form csoportok között */\n    width: 100%; /* A form is kihasználja a teljes szélességet */\n}\n\n.form-group {\n    margin-bottom: 20px;\n    display: flex;\n    flex-direction: column;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 8px; /* Nagyobb hely a címkék alatt */\n    color: #333;\n    font-weight: 600;\n}\n\n.form-group input, \n.form-group select, \n.form-group textarea {\n    width: 100%;\n    padding: 12px; /* Nagyobb padding */\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 16px; /* Nagyobb betűméret */\n}\n\n.specializacio-options {\n    display: flex;\n    justify-content: flex-start;\n    margin-bottom: 10px;\n}\n\n.specializacio-options label {\n    margin-right: 20px;\n    font-weight: 500;\n    color: #555;\n}\n\n.specializacio-item {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.specializacio-item label {\n    margin-left: 10px;\n    font-weight: 500;\n    color: #555;\n}\n\n.specializacio-item input {\n    flex-shrink: 0;\n    margin-right: 10px;\n}\n\nbutton {\n    padding: 12px 20px;\n    background-color: #44ACC9;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    font-size: 16px; /* Nagyobb gomb szöveg */\n    font-weight: bold;\n    align-self: flex-end; /* Igazítás jobbra */\n}\n\nbutton:hover {\n    background-color: #3a94b1;\n}\n\n/* Responsive stílusok */\n@media (max-width: 768px) {\n    .alapadatok-container {\n        padding: 20px;\n        max-width: 100%; /* Kis képernyőn teljes szélességet használ */\n    }\n\n    form {\n        gap: 15px; /* Kisebb térköz a form elemek között */\n    }\n\n    .form-group input, \n    .form-group select, \n    .form-group textarea {\n        padding: 10px; /* Kisebb padding kisebb képernyőkön */\n        font-size: 14px; /* Kisebb betűméret kisebb képernyőkön */\n    }\n\n    button {\n        padding: 10px 15px; /* Kisebb gomb méret kisebb képernyőkön */\n        font-size: 14px; /* Kisebb gomb szöveg */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
